const GET_SEARCH_LOADING = 'search/GET_SEARCH_LOADING'
const GET_SEARCH_SUCCESS = 'search/GET_SEARCH_SUCCESS'
// const GET_SEARCH_NO_RESULT = 'search/GET_SEARCH_NO_RESULT'
const GET_SEARCH_ERROR = 'search/GET_SEARCH_ERROR'

const GET_SUGGESTION_LOADING = 'search/GET_SUGGESTION_LOADING'
const GET_SUGGESTION_SUCCESS = 'search/GET_SUGGESTION_SUCCESS'
const GET_SUGGESTION_ERROR = 'search/GET_SUGGESTION_ERROR'

const GET_RECENT_SEARCH_LOADING = 'search/GET_RECENT_SEARCH_LOADING'
const GET_RECENT_SEARCH_SUCCESS = 'search/GET_RECENT_SEARCH_SUCCESS'
const GET_RECENT_SEARCH_ERROR = 'search/GET_RECENT_SEARCH_ERROR'

const DELETE_RECENT_SEARCH = 'search/DELETE_RECENT_SEARCH'

export {
  GET_SEARCH_LOADING,
  GET_SEARCH_SUCCESS,
  GET_SEARCH_ERROR,
  GET_SUGGESTION_LOADING,
  GET_SUGGESTION_SUCCESS,
  GET_SUGGESTION_ERROR,
  GET_RECENT_SEARCH_LOADING,
  GET_RECENT_SEARCH_SUCCESS,
  GET_RECENT_SEARCH_ERROR,
  DELETE_RECENT_SEARCH,
}
